// 日期選擇器快捷選項設定（無起辺效果，支持選今天、昨天、一周前）
export const unlimitOptions = {
  shortcuts: [{
    text: '今天',
    onClick (picker) {
      picker.$emit('pick', new Date())
    }
  }, {
    text: '昨天',
    onClick (picker) {
      const date = new Date()
      date.setTime(date.getTime() - 3600 * 1000 * 24)
      picker.$emit('pick', date)
    }
  }, {
    text: '一周前',
    onClick (picker) {
      const date = new Date()
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', date)
    }
  }]
}

// BootstrapVue 日期元件繁體中文展示文字設定
export const labels = {
  zh_TW: {
    weekdayHeaderFormat: 'narrow',
    labelPrevDecade: '過去十年',
    labelPrevYear: '上一年',
    labelPrevMonth: '上個月',
    labelCurrentMonth: '當前月份',
    labelNextMonth: '下個月',
    labelNextYear: '明年',
    labelNextDecade: '下一個十年',
    labelToday: '今天',
    labelSelected: '選定日期',
    labelNoDateSelected: '未選擇日期',
    labelCalendar: '日曆',
    labelNav: '日曆導航',
    labelHelp: '使用游標鍵瀏覽日期'
  }
}

// 日期區間選擇器快捷選項設定（支持最近一周、一個月、三個月）
export const pickerOptions2 = {
  shortcuts: [{
    text: '最近一周',
    onClick (picker) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近一個月',
    onClick (picker) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近三個月',
    onClick (picker) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    }
  }]
}

// 判斷是否為空字串 / null / undefined，或長度為 0
export function isEmpty (data) {
  return (!((data !== null) && (data !== undefined) && (data.length > 0)))
}

// 判斷是否為 null / undefined / 字串 'null'
export function isNull (data) {
  return (!((data !== null) && (data !== undefined) && (data !== 'null')))
}

// 判斷字串是否為 true（支持 'true'、'True'、boolean true）
export function isSuccess (str) {
  return (!!((str === 'true') || (str === 'True') || (str === true)))
}

// 判斷是否為 null、undefined、空字串或 'null'
export function isNullOrEmpty (str) {
  return (!!(!str || (str === 'null') || (str === null)))
}

// 判斷是否為 null、undefined、空白字串（僅针對 string 類型，非字串回傳 false）
export function isNullOrWhiteSpace (str) {
  var ret = false
  if (typeof str === 'string') {
    ret = (!!(!str || (str === 'null') || (str.trim() === '')))
  }
  return ret
}

// 產生對應 {n} 佔位符的正則表示式，用於 stringFormat 內部替換
export function getStringFormatPlaceHolderRegEx (placeHolderIndex) {
  return new RegExp('({)?\\{' + placeHolderIndex + '\\}(?!})', 'gm')
}

// 清除字串中所有未被替換的 {n} 佔位符，避免殘留展示
export function cleanStringFormatResult (txt) {
  if (txt === null) return ''
  return txt.replace(getStringFormatPlaceHolderRegEx('\\d+'), '')
}

/**
 * 類似 C# String.Format，將 {0}、{1}... 佔位符依序替換為對應參數。
 * 用法：stringFormat("{0}/{1}/{2}", yyyy, mm, dd)
 */
export function stringFormat () {
  var s = arguments[0]
  if (s === null) {
    return ''
  }
  for (var i = 0; i < arguments.length - 1; i++) {
    var reg = getStringFormatPlaceHolderRegEx(i)
    s = s.replace(reg, (arguments[i + 1] === null ? '' : arguments[i + 1]))
  }
  return cleanStringFormatResult(s)
}

// 建立於年、月、日數字小於 10 時補齊前置零（例：5 → "05"）
export function addLeftZero (param) {
  if (param < 10) {
    param = stringFormat('0{0}', param)
  }
  return param
}

// 驗證日期是否有效：必須非 null 且年份 > 1900
export function checkDateTime (dt) {
  var ret = false
  var date = null

  if (dt !== null) {
    var y1 = 0
    if (typeof dt === 'string') {
      date = new Date(dt)
    } else {
      date = dt
    }

    y1 = date.getFullYear()
    ret = (y1 > 1900)
  }
  return ret
}

/**
 * 驗證居民身分證字號（本國）或居留證號（外籍）
 * 回傳空字串表示通過；回傳錯誤文字表示失敗。
 * - 本國：第 1 碼英文字母 + 9 碼數字，使用加權相乘累加檢查。
 * - 外籍：第 1、2 碼均為英文字母，第 2 碼轉換方式與第 1 碼相同但取余數。
 */
export function checkIdentifyNumber (idNumber) {
  var checkFg = false
  var oIdNumber = idNumber.toUpperCase()

  if (oIdNumber.length !== 10) {
    return '證號長度不符'
  } else {
    var idHeader = 'ABCDEFGHJKLMNPQRSTUVXYWZIO' // 按照轉換後權數的大小進行排序

    // 本國人
    // 驗證填入身分證字號長度及格式
    // 用正則表示式比對第一個字母是否為英文字母
    if (!isNaN(oIdNumber.substr(1, 9)) &&
           (/^[A-Z]$/.test(oIdNumber.substr(0, 1)))) {
      // 這邊把身分證字號轉換成準備要對應的
      var studIdNumber = (idHeader.indexOf(oIdNumber.substring(0, 1)) + 10) + '' + oIdNumber.substr(1, 9)
      // 開始進行身分證數字的相乘與累加，依照順序乘上1987654321
      var s = parseInt(studIdNumber.substr(0, 1)) +
                    parseInt(studIdNumber.substr(1, 1)) * 9 +
                    parseInt(studIdNumber.substr(2, 1)) * 8 +
                    parseInt(studIdNumber.substr(3, 1)) * 7 +
                    parseInt(studIdNumber.substr(4, 1)) * 6 +
                    parseInt(studIdNumber.substr(5, 1)) * 5 +
                    parseInt(studIdNumber.substr(6, 1)) * 4 +
                    parseInt(studIdNumber.substr(7, 1)) * 3 +
                    parseInt(studIdNumber.substr(8, 1)) * 2 +
                    parseInt(studIdNumber.substr(9, 1))

      var checkNum = parseInt(studIdNumber.substr(10, 1))
      // 模數 - 總和/模數(10)之餘數若等於第九碼的檢查碼，則驗證成功
      // 若餘數為0，檢查碼就是0
      if ((s % 10) === 0 || (10 - s % 10) === checkNum) {
        checkFg = true
      }
    } else if (!isNaN(oIdNumber.substr(2, 8)) &&
               (/^[A-Z]$/.test(oIdNumber.substr(0, 1))) &&
               (/^[A-Z]$/.test(oIdNumber.substr(1, 1)))) {
      // 外籍生，居留證號規則跟身分證號差不多，只是第二碼也是英文字母代表性別，跟第一碼轉換二位數字規則相同，但只取餘數
      // 驗證填入身分證字號長度及格式
      // 用正則表示式比對第一&&第二個字母是否為英文字母
      if (isNaN(oIdNumber.substr(2, 8)) ||
               (!/^[A-Z]$/.test(oIdNumber.substr(0, 1))) ||
               (!/^[A-Z]$/.test(oIdNumber.substr(1, 1)))) {
        return '證號格式錯誤'
      }

      // 這邊把身分證字號轉換成準備要對應的
      studIdNumber = (idHeader.indexOf(oIdNumber.substring(0, 1)) + 10) +
            '' + ((idHeader.indexOf(oIdNumber.substr(1, 1)) + 10) % 10) + '' + oIdNumber.substr(2, 8)
      // 開始進行身分證數字的相乘與累加，依照順序乘上1987654321

      s = parseInt(studIdNumber.substr(0, 1)) +
                parseInt(studIdNumber.substr(1, 1)) * 9 +
                parseInt(studIdNumber.substr(2, 1)) * 8 +
                parseInt(studIdNumber.substr(3, 1)) * 7 +
                parseInt(studIdNumber.substr(4, 1)) * 6 +
                parseInt(studIdNumber.substr(5, 1)) * 5 +
                parseInt(studIdNumber.substr(6, 1)) * 4 +
                parseInt(studIdNumber.substr(7, 1)) * 3 +
                parseInt(studIdNumber.substr(8, 1)) * 2 +
                parseInt(studIdNumber.substr(9, 1))

      // 檢查號碼 = 10 - 相乘後個位數相加總和之尾數。
      checkNum = parseInt(studIdNumber.substr(10, 1))
      // 模數 - 總和/模數(10)之餘數若等於第九碼的檢查碼，則驗證成功
      /// 若餘數為0，檢查碼就是0
      if ((s % 10) === 0 || (10 - s % 10) === checkNum) {
        checkFg = true
      }
    }
  }
  return (checkFg ? '' : '證號格式錯誤')
}

// 內部函式：將字串轉換為 UTF-8 編碼，供 Base64 encode 使用
function utf8Encode (string) {
  string = string.replace(/\r\n/g, '\n')
  var utftext = ''

  for (var n = 0; n < string.length; n++) {
    var c = string.charCodeAt(n)

    if (c < 128) {
      utftext += String.fromCharCode(c)
    } else if ((c > 127) && (c < 2048)) {
      utftext += String.fromCharCode((c >> 6) | 192)
      utftext += String.fromCharCode((c & 63) | 128)
    } else {
      utftext += String.fromCharCode((c >> 12) | 224)
      utftext += String.fromCharCode(((c >> 6) & 63) | 128)
      utftext += String.fromCharCode((c & 63) | 128)
    }
  }

  return utftext
}

// 內部函式：將 UTF-8 比特流解碼回字串，供 Base64 decode 使用
function utf8Decode (utftext) {
  var string = ''
  var i = 0; var c = 0; var c3 = 0; var c2 = 0
  while (i < utftext.length) {
    c = utftext.charCodeAt(i)
    if (c < 128) {
      string += String.fromCharCode(c)
      i++
    } else if ((c > 191) && (c < 224)) {
      c2 = utftext.charCodeAt(i + 1)
      string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
      i += 2
    } else {
      c2 = utftext.charCodeAt(i + 1)
      c3 = utftext.charCodeAt(i + 2)
      string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63))
      i += 3
    }
  }
  return string
}

// 將字串進行 Base64 編碼
export function encode (input) {
  var _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
  var output = ''
  var chr1, chr2, chr3, enc1, enc2, enc3, enc4
  var i = 0
  input = utf8Encode(input)
  while (i < input.length) {
    chr1 = input.charCodeAt(i++)
    chr2 = input.charCodeAt(i++)
    chr3 = input.charCodeAt(i++)
    enc1 = chr1 >> 2
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
    enc4 = chr3 & 63
    if (isNaN(chr2)) {
      enc3 = enc4 = 64
    } else if (isNaN(chr3)) {
      enc4 = 64
    }
    output = output +
            _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
            _keyStr.charAt(enc3) + _keyStr.charAt(enc4)
  }
  return output
}

// 將 Base64 字串解碼回原始字串
export function decode (input) {
  var _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
  var output = ''
  var chr1, chr2, chr3
  var enc1, enc2, enc3, enc4
  var i = 0
  input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '')
  while (i < input.length) {
    enc1 = _keyStr.indexOf(input.charAt(i++))
    enc2 = _keyStr.indexOf(input.charAt(i++))
    enc3 = _keyStr.indexOf(input.charAt(i++))
    enc4 = _keyStr.indexOf(input.charAt(i++))
    chr1 = (enc1 << 2) | (enc2 >> 4)
    chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
    chr3 = ((enc3 & 3) << 6) | enc4
    output = output + String.fromCharCode(chr1)
    if (enc3 !== 64) {
      output = output + String.fromCharCode(chr2)
    }
    if (enc4 !== 64) {
      output = output + String.fromCharCode(chr3)
    }
  }
  output = utf8Decode(output)
  return output
}

// 辨別單一字元的類型：回傳 1=數字、2=大寫英文、4=小寫英文、8=特殊字元
function charMode (iN) {
  let ret = 0

  if ((iN >= 48) && (iN <= 57)) { // 數字
    ret = 1
  } else if ((iN >= 65) && (iN <= 90)) { // 大寫字母
    ret = 2
  } else if ((iN >= 97) && (iN <= 122)) { // 小寫
    ret = 4
  } else { // 特殊字符
    ret = 8
  }

  return ret
}

// 計算數字中二進位为 1 的個數，用於統計密碼拱有多少種字元類型
function bitTotal (num) {
  let modes = 0

  for (var i = 0; i < 4; i++) {
    if (num & 1) {
      modes++
    }
    num >>>= 1
  }

  return modes
}

/**
 * 密碼強度檢查，回傳平均 bitTotal 分數（包含字元類型的種類數）。
 * 回傳値：1=太短(<= 7 碼)，2=弱，3=中，4=強（三種以上字元類型）。
 */
export function checkStrong (sPW) {
  let modes = 0

  if (sPW.length <= 7) {
    return 1 // 密碼太短
  }

  for (var i = 0; i < sPW.length; i++) {
    // 測試每一個字符的類別並統計一共有多少種模式.
    modes |= charMode(sPW.charCodeAt(i))
  }

  return bitTotal(modes)
}

// 將日期格式化為 yyyy-MM-dd，接受 Date 物件或日期字串
export function getDateFormat (dt) {
  // getMonth回傳值為0-11, 所以加1
  var date = null
  if (dt != null) {
    if (typeof dt === 'string') {
      date = new Date(dt)
    } else {
      date = dt
    }
    return stringFormat('{0}-{1}-{2}', addLeftZero(date.getFullYear()), addLeftZero(date.getMonth() + 1), addLeftZero(date.getDate()))
  }
};

// 將日期轉換為僅含年月日（去除時分秒）的 Date 物件
export function getDateTime (dt) {
  var y1 = 0; var m1 = 0; var d1 = 0
  var date = null

  if (dt != null) {
    if (typeof dt === 'string') {
      date = new Date(dt)
    } else {
      date = dt
    }

    y1 = date.getFullYear()
    m1 = date.getMonth()
    d1 = date.getDate()

    return new Date(y1, m1, d1)
  }
};

// 將指定時間戳格式化為 "yyyy-MM-dd HH:mm:ss"
export function getToday (updateTime) {
  var dd = new Date(updateTime)
  var today = dd.getDate().toString().padStart(2, '0') // 內建getDate 取到目前年月日
  var mm = (dd.getMonth() + 1).toString().padStart(2, '0') // January is 0!
  var yyyy = dd.getFullYear()
  var hours = dd.getHours().toString().padStart(2, '0')
  var minutes = dd.getMinutes().toString().padStart(2, '0')
  var seconds = dd.getSeconds().toString().padStart(2, '0')

  return tools.stringFormat('{0}-{1}-{2} {3}:{4}:{5}', yyyy, mm, today, hours, minutes, seconds)
};

// 建立 Date 物件（月份為 0-基準，傳入時請不加一）
export function setDate (yy, mm, dd) {
  return new Date(yy, mm, dd)
};

/**
 * 以 BootstrapVue Toast 顯示警示訊息。
 * @param {Vue} vm - Vue 元件實例
 * @param {string} type - 樣式（'danger'、'success'、'warning' 等）
 * @param {string} text - 要顯示的訊息內容
 */
export function showAlert (vm, type, text) {
  if (!isNull(vm)) {
    const h = vm.$createElement
    const vNodesMsg = h(
      'div',
      { class: ['alert-text'] },
      [
        h('strong', text)
      ]
    )
    vm.$bvToast.toast(vNodesMsg, {
      title: '請注意',
      variant: type,
      toaster: 'b-toaster-top-center',
      autoHideDelay: 5000,
      solid: true
    })
  }
};

/**
 * 驗證中華民國居民身分證字號（格式：大寫英文字母 + 1/2 + 8碼數字）。
 * 使用內政部印證局崖碼表將字母轉換後，以加權相乘累加再檢查 mod 10 = 0。
 * @param {string} id - 要驗證的身分證字號
 * @returns {boolean} 合法傳回 true
 */
export function checkTWID (id) {
  const cityCode = {
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    G: 16,
    H: 17,
    I: 34,
    J: 18,
    K: 19,
    L: 20,
    M: 21,
    N: 22,
    O: 35,
    P: 23,
    Q: 24,
    R: 25,
    S: 26,
    T: 27,
    U: 28,
    V: 29,
    W: 32,
    X: 30,
    Y: 31,
    Z: 33
  }

  if (/^[A-Z][1-2]\d{8}$/.test(id)) {
    const letters = id.charAt(0)
    const nums = id.substring(1)
    const num = cityCode[letters]
    const str = num.toString() // 將數字轉換為字串
    const digit1 = str.charAt(0) // 取得個位數
    const digit2 = str.charAt(1) // 取得十位數
    const result1 = parseInt(digit1) * 1 // 第一個數字乘上1
    const result2 = parseInt(digit2) * 9 // 第二個數字乘上9

    let total = result1 + result2
    for (let i = 0; i < 8; i++) {
      total += parseInt(nums.charAt(i)) * (8 - i)
    }
    total += parseInt(nums.charAt(8))
    return total % 10 === 0
  } else {
    return false
  }
};

// 舊版居留證（ARC old）：第2碼為 A/B/C/D，2021年以前發行
export function checkARC_old (id) {
  const conver = 'ABCDEFGHJKLMNPQRSTUVXYWZIO'
  if (!/^[A-Z][ABCD]\d{8}$/.test(id)) return false
  const weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1]
  // 第1碼：查 cityCode（同身分證）；第2碼：查 conver 後只取個位數
  const cityCode = {
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    G: 16,
    H: 17,
    I: 34,
    J: 18,
    K: 19,
    L: 20,
    M: 21,
    N: 22,
    O: 35,
    P: 23,
    Q: 24,
    R: 25,
    S: 26,
    T: 27,
    U: 28,
    V: 29,
    W: 32,
    X: 30,
    Y: 31,
    Z: 33
  }
  const c1 = cityCode[id[0]].toString()
  const c2 = ((conver.indexOf(id[1]) + 10) % 10).toString()
  const digits = c1 + c2 + id.slice(2)
  let total = 0
  for (let i = 0; i < digits.length; i++) {
    total += parseInt(digits[i]) * weights[i]
  }
  return total % 10 === 0
};

/**
 * 新版居留證（ARC new）：第2碼為 8（男）或 9（女），2021年起換發。
 * 演算法與身分證相同（加權 1,9,8,7,6,5,4,3,2,1,1），但第2碼須直接以 8 或 9
 * 帶入計算，不可替換為 1/2，否則檢查碼結果會不同。
 */
export function checkARC_new (id) {
  if (!/^[A-Z][89]\d{8}$/.test(id)) return false
  const cityCode = {
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    G: 16,
    H: 17,
    I: 34,
    J: 18,
    K: 19,
    L: 20,
    M: 21,
    N: 22,
    O: 35,
    P: 23,
    Q: 24,
    R: 25,
    S: 26,
    T: 27,
    U: 28,
    V: 29,
    W: 32,
    X: 30,
    Y: 31,
    Z: 33
  }
  const weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1]
  // 11碼序列：[區碼十位][區碼個位][第2碼8/9直接使用][後8碼]
  const digits = cityCode[id[0]].toString() + id.slice(1)
  let total = 0
  for (let i = 0; i < 11; i++) {
    total += parseInt(digits[i]) * weights[i]
  }
  return total % 10 === 0
};

// 自動辨識新舊版，兩版皆接受
export function checkARC (id) {
  return checkARC_old(id) || checkARC_new(id)
};

/**
 * 驗證身分證/統一證號的性別碼是否與填寫的關係相符。
 * 僅對「父親」(1) 和「母親」(2) 進行交叉驗證；配偶/法定代理人不檢查。
 *
 * 性別碼規則（依內政部移民署規格）：
 *
 * ─ 國民身分證（nationality === 'TW'）
 *   格式：1碼英文 + 9碼數字
 *   第2碼：1 = 男性，2 = 女性
 *
 * ─ 統一證號（nationality !== 'TW'，外國人/無戶籍國民/港澳/大陸人士）
 *   新式（110/01/02 起核發）：1碼英文 + 9碼數字，第2碼：8 = 男性，9 = 女性
 *   舊式（110/01/01 前核發）：2碼英文 + 8碼數字，第2碼：
 *     A = 外僑永久居留男，B = 外僑一般居留男
 *     C = 外僑永久居留女，D = 外僑一般居留女
 *
 * 注意：統一證號即居留證號，二者格式相同。
 *
 * @param {string} id - 已大寫的身分證或統一證號
 * @param {string} nationality - 'TW'（本國籍）或其他值（外國籍/統一證號）
 * @param {number|null} relationship - 1=父親, 2=母親, 3=配偶, 5=法定代理人
 * @returns {boolean} 相符或無需檢查時回傳 true；性別與關係不符時回傳 false
 */
export function checkGenderMatch (id, nationality, relationship) {
  // 僅檢查父親(1)與母親(2)；配偶、法定代理人、null/未選擇 → 不阻擋
  if (relationship !== 1 && relationship !== 2) return true
  // 證號尚未輸入或太短 → 等格式驗證阻擋即可，本函式不重複攔截
  if (!id || id.length < 2) return true

  const expectMale = relationship === 1 // 父親 → 期望男性；母親 → 期望女性

  let isMale
  if (nationality === 'TW') {
    // 國民身分證：第2碼 '1'=男，'2'=女
    isMale = id.charAt(1) === '1'
  } else {
    // 統一證號：依第2碼區分新式與舊式
    const c2 = id.charAt(1)
    if (c2 === '8' || c2 === 'A' || c2 === 'B') {
      // 新式男（8）或舊式男（A=永久居留、B=一般居留）
      isMale = true
    } else if (c2 === '9' || c2 === 'C' || c2 === 'D') {
      // 新式女（9）或舊式女（C=永久居留、D=一般居留）
      isMale = false
    } else {
      // 第2碼不在已知性別碼範圍內（例如其他證別）→ 無法判斷，不阻擋
      return true
    }
  }

  return isMale === expectMale
};
